import React, { useEffect } from "react";
import history from "../../../../../utils/history";
import Panel from "../../../../ui/panel/Panel";
import Text from "../../../../ui/text/Text";
import "./AdjustmentMadeToNextBillEmailTemplate.scss";
import { IAuthReducerState } from "../../../../../reducers/authReducer";
import { Row, Col } from "react-grid-system";
import EmailPreivewContainer from "../../brand-customization/email-preview/EmailPreivewContainer";
import BackNavigationPanel from "../../../../ui/back-navigation-panel/BackNavigationPanel";
import { IEmailCustomizationReducerState } from "../../../../../reducers/emailCustomizationReducer";
import { resetEmailTemplateValues, getEmailTemplateValues } from "../../../../../actions/emailCustomizationActions";
import { fetchCompanyBranding } from "../../../../../actions/companyBrandingActions";
import EmailFooter from "../email-footer/EmailFooter";
import EmailEditableArea from "../email-editable-area/EmailEditableArea";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../..";
import { ICompanyBrandingReducerState } from "../../../../../reducers/companyBrandingReducer";
import { EmailTypes } from "../../../../../utils/grpc/generated/Billsby.Protos/Messenger/private/emailconfig/emailconfig_pb";


const AdjustmentMadeToNextBillEmailTemplate: React.FC = () => {

  const authReducer = useSelector<AppState, IAuthReducerState>(state => state.auth);
  const amtnbe_emailCustomizationReducer = useSelector<AppState, IEmailCustomizationReducerState>(state => state.emailCustomizationReducer);
  const amtnbe_companyBrandingReducer = useSelector<AppState, ICompanyBrandingReducerState>(state => state.companyBrandingReducer);
  const dispatch = useDispatch();
  const { customArea1, customArea2 } = amtnbe_emailCustomizationReducer;
  const { currentCompanyId, companyName, currentCompanyDomain } = authReducer;


  useEffect(() => {
    dispatch(fetchCompanyBranding(currentCompanyDomain));
    dispatch(getEmailTemplateValues(currentCompanyId as number, companyName, EmailTypes.NEXT_BILL_ADJUSTMENT));
    return () => { dispatch(resetEmailTemplateValues()) };
  }, []);


  return (
    <div id="AdjustmentMadeToNextBillEmailTemplate-wrapper">
      <BackNavigationPanel
        title={"EMAIL_TEMPLATE_ADJUSTMENT_MADE_TO_NEXT_BILL_BACK_PANEL_TITLE"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/email-notifications/emails/payment-credits-refund")} />

      <Row>
        <Col sm={8}>
          <Panel className="adjustment-made-to-net-bill-email-template__panel" noMargin>
            <EmailPreivewContainer>

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea1}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text email-preview__details__text-title bar bar-blue"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_ADJUSTMENT_MADE_TO_NEXT_BILL_GREETINGS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea2}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text bar bar-orange"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_ADJUSTMENT_MADE_TO_NEXT_BILL_BODY_1"
                className="email-preview__details__text email-preview__details__text-bold"
                component="span"
                noMargin
              />

              <Row>
                <Col md={3}>
                  <Text
                    content="EMAIL_TEMPLATE_ADJUSTMENT_MADE_TO_NEXT_BILL_BODY_2"
                    className="email-preview__details__text"
                    component="span"
                    noMargin
                  />
                </Col>
                <Col md={9}>
                  <Text
                    content="EMAIL_TEMPLATE_ADJUSTMENT_MADE_TO_NEXT_BILL_BODY_3"
                    className="email-preview__details__text"
                    component="span"
                    noMargin
                  />
                </Col>
              </Row>

              <Text
                content="EMAIL_TEMPLATE_ADJUSTMENT_MADE_TO_NEXT_BILL_BODY_4"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_ADJUSTMENT_MADE_TO_NEXT_BILL_REAGRDS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={companyName}
                className="email-preview__details__text"
                component="span"
                shouldTranslate={false}
                noMargin
              />

              <EmailFooter />
              
            </EmailPreivewContainer>
          </Panel>
        </Col>
        <Col sm={4}>

        <EmailEditableArea
          id="AdjustmentMadeToNextBillEmailTemplate"
          emailCustomCopyOneValue={customArea1}
          emailCustomCopyTwoValue={customArea2}
          emailCustomCopyThreeValue=""
          emailCustomCopyThreeIsVisible={false}
          showCompanyAlertToggle={true}
          showProductAlertToggle={true}
          showPlanAlertToggle={true}
        />
        </Col>
      </Row>
    </div>
  )
}

export default AdjustmentMadeToNextBillEmailTemplate